import { createContext, useContext, useState, useCallback } from 'react'

export const BackContext = createContext({ backHandler: null, setBackHandler: () => {} })

export const useBack = () => useContext(BackContext)

export const useBackState = () => {
	const [backHandler, setBackHandlerState] = useState(null)
	const setBackHandler = useCallback((fn) => setBackHandlerState(() => fn), [])
	return { backHandler, setBackHandler }
}
